import omit from 'ramda/src/omit'
import mergeAll from 'ramda/src/mergeAll'
import compose from 'ramda/src/compose'
import assoc from 'ramda/src/assoc'

const removeModelRefs = omit(['model', 'modelAovId', 'modelId'])
const setUserSelectedPpfNightModeToFalse = assoc('userSelectedPpfNightMode', false)
const clearModelWork = compose(removeModelRefs, setUserSelectedPpfNightModeToFalse)

export default function clearModelReferences(state, action) {
  const { id } = action
  const { cameras } = state

  return mergeAll([{}, state, {
    cameras: [
      ...cameras.filter(c => c.id !== id),
      clearModelWork(cameras.find(c => c.id === id))
    ]
  }])
}



// WEBPACK FOOTER //
// ./src/reducers/clearModelReferences.js